import { useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import invalidateCaches from '../helpers/invalidateCaches';

const TRANSACTION_ERROR_CODE = 'TRANSACTION_ERROR';

const useShowErrorOrRedirectThankYouPageV2 = (navigate, thankYouPagePath, couponCode) => {
  const initialState = {
    showPayment: false,
    errorPaymentMessage: '',
    showRetry: false,
    isLoading: false,
  };

  const [currentState, setCurrentState] = useState(initialState);

  const setLoading = (loadingBool) => {
    setCurrentState({
      ...initialState,
      isLoading: loadingBool,
    });
  };

  const onClose = () => {
    setCurrentState(initialState);
  };

  const handlePlanChangeResponse = async (response) => {
    if (response.ok) {
      // Await so both cache layers are busted before we navigate to the thank-you page,
      // which reads fresh subscription state (see useShowPayErrorOrThankYouPage).
      await invalidateCaches();
      datadogLogs.logger.info('Reactivation redirecting to thanks page', {
        status: response.status,
        ok: response.ok,
      });
      navigate(thankYouPagePath, {
        state: { coupon_code: couponCode || '' },
      });
    } else if (response.status === 422) {
      const body = await response.json();
      if (body.errorCode === TRANSACTION_ERROR_CODE) {
        setCurrentState({
          ...initialState,
          showPayment: true,
          errorPaymentMessage: body.message,
        });
      } else {
        setCurrentState({
          ...initialState,
          showRetry: true,
        });
      }
    } else {
      setCurrentState({
        ...initialState,
        showRetry: true,
      });
    }
  };

  return {
    ...currentState,
    onClose,
    handlePlanChangeResponse,
    setLoading,
  };
};

export default useShowErrorOrRedirectThankYouPageV2;
